const SEASONAL_EVENTS = [
  {
    name: 'blackfriday',
    date: { month: 10, startDay: 17, endDay: 30 }, // November (0-based)
    label: (year) => `Black Friday ${year}`,
    isActive: function () {
      const now = new Date();
      const month = now.getMonth();
      const day = now.getDate();

      return (
        month === this.date.month &&
        day >= this.date.startDay &&
        day <= this.date.endDay
      );
    },
  },
  // Add new events here
];

export const getSeasonalEventPrefix = () => {
  const year = new Date().getFullYear();

  for (const event of SEASONAL_EVENTS) {
    if (event.isActive()) {
      return event.label(year);
    }
  }

  return null;
};
